import dayjs, { Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { LocalizationProvider } from '@mui/x-date-pickers';
import type {} from '@mui/x-date-pickers/AdapterDayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { useField } from 'react-final-form';

dayjs.extend(customParseFormat);

const normalizeDate = (val: any): Dayjs | null => {
  if (!val) return null;

  if (dayjs.isDayjs(val)) {
    return val.isValid() ? val : null;
  }

  if (typeof val === 'string') {
    let parsed = dayjs(val);
    if (parsed.isValid()) return parsed;

    parsed = dayjs(val, 'DD/MM/YYYY', true);
    if (parsed.isValid()) return parsed;
  }

  const finalParsed = dayjs(val);
  return finalParsed.isValid() ? finalParsed : null;
};

export const DatePickerAdapter = ({
  input: { name, value },
  disableOpenPicker,
  disabled,
  noFuture,
  setValue,
  ...rest
}: any) => {
  const { input, meta } = useField(name);

  const onChange = (newValue) => {
    if (newValue && dayjs(newValue).isValid()) {
      input.onChange(newValue.format('YYYY-MM-DD'));
      if (setValue) setValue(newValue);
    } else {
      input.onChange(null);
      if (setValue) setValue(null);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DesktopDatePicker<Dayjs>
        format="DD/MM/YYYY"
        value={normalizeDate(value)}
        disableFuture={noFuture ? true : false}
        onChange={onChange}
        disableOpenPicker={disableOpenPicker ?? false}
        disabled={disabled ?? false}
        slotProps={{
          textField: {
            ...rest,
            helperText: meta.touched ? meta.error : '',
            error: !!(meta.error && meta.touched),
            fullWidth: true
          }
        }}
      />
    </LocalizationProvider>
  );
};
